<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->

      <!--Row-->
      <div class="row row-sm">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
          <div class="card">
            <div class="card-body pb-0 border-bottom">
              <div class="d-flex mb-3">
                <h6 class="card-title mb-0">All Vendors</h6>
                <div class="ml-auto d-md-flex">
                  <div class="mr-2">
                    <router-link to="/createvendor"
                      ><button class="btn btn-primary btn-sm rounded-lg fs-13">
                        <i class="mdi mdi-plus-circle-outline"></i>Create New
                        Vendor
                      </button></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="table-responsive">
                <table
                  id="example"
                  class="table table-striped"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>Registered Company Name</th>

                      <th>RC Number</th>
                      <th>Office Phone No</th>
                      <th>Tax ID No</th>
                      <th>Email</th>
                      <th>Website</th>
                      <th>Industry</th>
                      <th>No Of Staff</th>

                      <th>View / Upload Vendor Documents</th>
                      <th>View More / Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="vendor in vendors" :key="vendor.id">
                      <td>{{ vendor.registeredCompanyName }}</td>

                      <td>{{ vendor.companyRegistrationNumber }}</td>
                      <td>{{ vendor.telephoneNumber }}</td>
                      <td>{{ vendor.taxIdentificationNumber }}</td>
                      <td>{{ vendor.email }}</td>
                      <td>{{ vendor.website }}</td>
                      <td>{{ vendor.industry }}</td>
                      <td>{{ vendor.numberOfStaff }}</td>

                      <td>
                        <router-link
                          :to="{
                            name: 'Vendor Documents',
                            params: { id: vendor.id },
                          }"
                          ><button class="btn btn-primary">
                            View / Upload Documents
                          </button></router-link
                        >
                      </td>

                      <td>
                        <router-link
                          :to="{
                            name: 'Edit Vendor',
                            params: { id: vendor.id },
                          }"
                          ><button class="btn btn-primary">
                            View More / Edit
                          </button></router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- COL END -->
      </div>
    </div>
    <!--Main Content Container-->
  </div>
  <!--Main Content-->
</template>

<script>
import $ from "jquery";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Breadcrumb,
  },
  props: ["user", "BaseURL"],
  data() {
    return {
      vendors: [],
    };
  },

  methods: {},
  // beforeCreate() {
  //   if (localStorage.getItem("role") !== "Admin") {
  //     window.location = "/error";
  //   }
  // },

  mounted() {
    fetch(this.BaseURL + "/getAllVendor", {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        this.vendors = data;
        $(() => {
          $("#example").DataTable();
        });
      });
  },
};
</script>